"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = getAll;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _qs = _interopRequireDefault(require("qs"));

var _ = require(".");

function getAll(_x, _x2, _x3) {
  return _getAll.apply(this, arguments);
}

function _getAll() {
  _getAll = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, item, search) {
    var client, path, request, response, _ref3, _ref3$response;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, path = _ref.path;
            request = search ? Object.assign(item, search) : item;
            _context.prev = 2;
            _context.next = 5;
            return client.get(path, {
              headers: {
                Accept: _.APPLICATION_JSON
              },
              params: Object.fromEntries(Object.entries(request).filter(function (_ref2) {
                var k = _ref2[0],
                    v = _ref2[1];
                return (v != null ? v : null) != null;
              })),
              paramsSerializer: function paramsSerializer(params) {
                return _qs.default.stringify(params, {
                  arrayFormat: 'repeat',
                  allowDots: true
                });
              }
            });

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

            if (!(((_ref3 = _context.t0) == null ? void 0 : (_ref3$response = _ref3.response) == null ? void 0 : _ref3$response.status) === 404)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", []);

          case 13:
            throw new Error("Failed to fetch object for filters: " + JSON.stringify(item) + " and path: " + path);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getAll.apply(this, arguments);
}